import { EFT_INSTRUCTIONS_CNCF, WIRING_INSTRUCTIONS_CNCF } from '../../lib/_core/constants/wiring-instructions';
import { EnvironmentNames } from '../../lib/_core/constants/environments';
import { environment as swissEnv } from '../swiss/environment.swiss-prod';

export const environment = {
  fund: {
    primaryColor: 'rgb(143, 152, 72)',
    secondaryColor: 'rgb(234,243,225)',
    ternaryColor: 'rgb(48, 48, 112)',
    logo: 'assets/logos/cncf.png',
    publicLogo: 'assets/logos/cncf.png',
    lightDonateNowButtonLink:
      'https://5664234.app.netsuite.com/core/media/media.nl?id=16221&c=5664234&h=WFB6SqSOKgf_GOjsu1H8mq6p-RazGKzh5bctuR2RGVUdkMdv',
    darkDonateNowButtonLink:
      'https://5664234.app.netsuite.com/core/media/media.nl?id=16220&c=5664234&h=2inHX_gmfj7-CYKgWAlxTYHQZd4iTcSbZkB90tL4LNnNcHLQ',
    lightDonateNowButtonSrc: 'assets/donate-buttons/cncf_light_donate_button.png',
    darkDonateNowButtonSrc: 'assets/donate-buttons/cncf_dark_donate_button.png',
    favicon: 'https://www.cncf.ca/wp-content/uploads/2019/02/cncffavicon.png',
    wiringInstructions: WIRING_INSTRUCTIONS_CNCF,
    eftInstructions: EFT_INSTRUCTIONS_CNCF,
    stripeKey:
      'pk_live_51IoXmNDg74LMNjlaioizaUQjkZzrPyFxDJ4ucZ1bbVhZTURPhiugyLR6N0it0rQAJtTt40QVMQifcKc80PI6RGwT00M9E9E9em',
    homeLink: 'https://www.cncf.ca/',
    contact: 'https://e-courier.ca/aQ?is=bDklonoH3V8e',
    blog: 'https://www.cncf.ca/stories-blogs',
    privacyPolicy: 'https://www.cncf.ca/privacy-policy',
    terms: 'https://www.cncf.ca/legal-disclaimer',
    mailTo: 'admin@cncf.ca',
    name: 'Canadian National Christian Foundation',
    tenantId: 'cncf_prod',
    server: 'https://portal.cncf.ca/api',
    url: 'http://portal.cncf.ca',
    gsUrl: 'https://givingspace.trustbridgeglobal.com/',
    environmentName: EnvironmentNames.CNCF,
    languages: ['en-cncf'],
    production: true,
    multiCurrency: false,
    redirectSourceUrl: swissEnv.fund.url,
    signatureApiKey: '82dbebd7-6b9f-4d06-ba49-f320cec3bae8',
  },
};
